import React from 'react';
import Configurator from './Configurator.jsx';
import styles from './PatchcordConfigurator.styl';

/**
 * Конфигуратор патч-кордов
 */
class PatchcordConfigurator extends Configurator
{
	constructor(props) {
		super(props);
		this.onSwitchConfigurator = this.onSwitchConfigurator.bind(this);
	}

	getType() {
		return 'patchcord';
	}

	onSwitchConfigurator() {
		if (this.props.onSwitchConfigurator) {
			this.props.onSwitchConfigurator();
		}
	}

	getCustomElements() {
		let elements = [];

		elements.push(
			<label className={styles.confTypePatchcord} key="patchcord">
				<span className={styles.confTypeTitle}>Патч-корд</span>
				<input className={styles.confTypeControl} name="itkcfg_filter_conf_type" type="radio" defaultChecked={true} />
			</label>
		);

		elements.push(
			<label className={styles.confTypePigtail} key="pigtail">
				<span className={styles.confTypeTitle}>Пигтейл</span>
				<input className={styles.confTypeControl} name="itkcfg_filter_conf_type" type="radio" defaultChecked={false} onChange={this.onSwitchConfigurator} />
			</label>
		);

		return elements;
	}

	getCustomStyles() {
		return styles;
	}
}

export default PatchcordConfigurator;



// WEBPACK FOOTER //
// ./src/react/PatchcordConfigurator.jsx